(function() {
	'use strict';

	angular
		.module('pwc.environment')
		.service('ENV', ENV);

	ENV.$inject = ['$window', '$log', 'lodash'];

	function ENV($window, $log, lodash) {

		if (lodash.contains($window.location.href, 'app.personalwinecurator.com'))
		{
            this.NAME = 'production';
            this.API_URL = 'https://api.personalwinecurator.com';
            this.STRIPE_KEY = 'pk_live_LdpBLc732kZjkobVDRS4zCYf';

            this.COUCH_URL = 'https://db.personalwinecurator.com';
            this.DEBUG = false;

		} else {

            this.NAME = 'local';
            this.API_URL = 'http://localhost:8000';
            this.STRIPE_KEY = 'pk_test_s3X8mCJErDsr4EDQkGehhxig';

            //this.COUCH_URL = 'http://127.0.0.1:5984';
			this.COUCH_URL = 'https://db.personalwinecurator.com';
            this.DEBUG = true;
		}

		this.ROLLBAR_KEY = '2d3819f06f7c4d72ad3f8b4dc925b26d';

		// default to USD, controlled in settings
		this.LOCALE_SYMBOL = '$';

		$log.debug('Environment', this.NAME);

	}

})();
